import { css } from '@emotion/css'

const styles = {
  wrapper: css({
    display: 'flex',
    overflowY: 'hidden',
  }),
  modal: css({
    background: '#fff',
    position: 'relative',
    padding: '24px 0 0',
    maxWidth: '500px',
    display: 'flex',
    flexDirection: 'column',
  }),
}

export default styles
